import React, { useContext, useEffect, useRef, useState } from 'react';

import { toast } from 'react-toastify';
import { AppContext } from '../../../contexts/AppContext';
import useWarehouseOrderExtraService from '../../../app/services/hooks/useWareHouseOrderExtraServicesService';
import { WarehouseOrderShowRateDataForm } from '../../../app/models/WareHouseOrderRates';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import WarehouseOrderExtraServicesShowForm from './forms/WareHouseOrderExtraServicesForms/WareHouseOrderExtraServicesShowForm';
import LazyLoading from '../../../components/LazyLoading';

interface Props {
    extraServiceId: number;
    onSaved?: () => void;
    onCancel: () => void;
    onError?: () => void;
}

const WarehouseQuoteExtraServiceShow = ({
    extraServiceId,
    onSaved,
    onCancel,
    onError
}: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const {showWarehouseOrderExtraService,fetchingShowWarehouseOrderExtraService} =
        useWarehouseOrderExtraService();

    const [showExpedition, setShowExpedition] = useState<WarehouseOrderShowRateDataForm>({});

    useEffect(() => {
        show();
    }, [extraServiceId]);

    const show = () => {
        showWarehouseOrderExtraService(extraServiceId, {
                onSuccess: (response: ServiceResponse) => {
                    setShowExpedition(response.data.extra_service);

                },

        });
    };

    return (

        <>
                        {!fetchingShowWarehouseOrderExtraService ? (
                            <>
                                <WarehouseOrderExtraServicesShowForm 
                                extraServiceDataForm={showExpedition}
                                />
                            </>
                        ) : (
                            <LazyLoading />
                        )}

        </>
    );
};

export default WarehouseQuoteExtraServiceShow;
